import useRead from '../useRead';

const useGetBanner = ({ bannerId, onSuccess } = {}) => {
  const {
    data,
    paramsObject,
    setGetListParams,
  } = useRead({
    url: "banner/view",
    initialData: bannerId ? { banner_id: bannerId } : {},
    method: "GET",
    enabled: !!bannerId,
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data);
      }
    },
  });

  return {
    data,
    paramsObject,
    setGetListParams,
  };
};

export default useGetBanner;
